<!-- 账号管理 -->
<style scoped>
.width150 {
  width: 150px;
}
</style>
<template>
  <div>
    <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
      <!-- 搜索条件 -->
      <a-form-model
        size="small"
        layout="inline"
        :model="ajaxparams"
        @keyup.native.enter="$refs.myTable.search()"
      >
        <a-form-model-item label="订单号">
          <a-input
            placeholder="请输入订单号"
            v-model="ajaxparams['2_order_sn_like']"
          />
        </a-form-model-item>
        <a-form-model-item label="用户">
          <a-input
            placeholder="请输入用户"
            v-model="ajaxparams['3_name_like']"
          />
        </a-form-model-item>
        <a-form-model-item label="商品名称">
          <a-input
            placeholder="请输入商品名称"
            v-model="ajaxparams['1_goods_name_like']"
          />
        </a-form-model-item>
        <a-form-model-item label="是否定制">
          <a-select
            style="width: 200px"
            allowClear
            v-model="ajaxparams['2_is_customized']"
            placeholder="是否定制单"
          >
            <a-select-option value="0">非定制单</a-select-option>
            <a-select-option value="1">定制单</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="品牌">
          <a-select
            style="width: 200px"
            allowClear
            v-model="ajaxparams['1_brand_id']"
            placeholder="请选择品牌"
          >
            <a-select-option
              :value="item.id"
              v-for="(item, index) in brandData"
              :key="index"
              >{{ item.brand_name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="省份">
          <a-select
            style="width: 200px"
            allowClear
            v-model="ajaxparams['2_province_code']"
            placeholder="请选择省份"
            :showSearch="true"
            optionFilterProp="label"
          >
            <a-select-option
              :label="item.name"
              :value="item.code"
              v-for="(item, index) in provinceData"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="是否返利订单">
          <a-select
            style="width: 200px"
            allowClear
            v-model="ajaxparams['is_online_goods']"
            placeholder="请选择是否返利订单"
          >
            <a-select-option value="0">非返利订单</a-select-option>
            <a-select-option value="2">返利订单</a-select-option>
            <a-select-option value="1">到期可返利订单</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="日期">
          <a-range-picker
            style="margin-right: 10px"
            v-model="ajaxparams['2_ctime_between']"
            format="YYYY-MM-DD"
            valueFormat="YYYY-MM-DD"
            :disabled="ajaxparams['is_online_goods'] === '1'"
            :placeholder="
              ajaxparams['is_online_goods'] === '1'
                ? ['到期可返利时间范围', '固定为2022年至一年前']
                : ['开始日期', '结束日期']
            "
          />
        </a-form-model-item>
        <a-form-model-item>
          <a-button
            icon="search"
            @click="$refs.myTable.search()"
            type="primary"
          >
            搜索</a-button
          >
        </a-form-model-item>
        <a-form-model-item>
          <a-button v-if="canExport" @click="doExport" type="primary"> 导出 </a-button>
        </a-form-model-item>
      </a-form-model>
      <MyTable
        class="mt10"
        :apiUrl="orders_item"
        :params="getRequestParams()"
        ref="myTable"
        :columns="columns"
        :rowSelection="false"
        :scroll="{ x: 1420 }"
      >
        <a-space slot="order_sn" slot-scope="item, row, index">
          <router-link
            target="_blank"
            :to="{ path: '/orders/detail', query: { id: row.order_sn } }"
          >
            <span>{{ row.order_sn }}</span>
          </router-link>
        </a-space>

        <a-space slot="ctime" slot-scope="item, row, index">
          <span>{{ item.substr(0, 10) }}</span>
        </a-space>

        <a-space slot="is_delivery" slot-scope="item, row, index">
          <span>{{ item ? "已发货" : "未发货" }}</span>
        </a-space>

        <a-space slot="brand_id" slot-scope="item, row, index">
          <span>{{ findBrandName(item) }}</span>
        </a-space>
        <a-space slot="province_code" slot-scope="item, row, index">
          <span>{{ findProvinceName(item) }}</span>
        </a-space>

        <a-space slot="is_ready" slot-scope="item, row, index">
          <span>{{ item ? "已开单" : "未开单" }}</span>
        </a-space>
        <a-space slot="goods_amount" slot-scope="item, row, index">
          <span>{{ (row.goods_amount / 100).toFixed(2) }}</span>
        </a-space>
        <a-space slot="price" slot-scope="item, row, index">
          <span>{{ $common.countFloat((item ? item : 0) / 100, 2) }}</span>
        </a-space>
        <a-space slot="payed_amount" slot-scope="item, row, index">
          <span>{{ (row.payed_amount / 100).toFixed(2) }}</span>
        </a-space>
        <a-space slot="order_amount" slot-scope="item, row, index">
          <span>{{ (row.order_amount / 100).toFixed(2) }}</span>
        </a-space>
        <a-space slot="payed_coin" slot-scope="item, row, index">
          <span>{{ (row.payed_coin / 100).toFixed(2) }}</span>
        </a-space>

        <a-space
          slot="online_goods_refund_amount"
          slot-scope="item, row, index"
        >
          <span>¥{{ item ? (item / 100).toFixed(2) : "0.00" }}</span>
        </a-space>

        <a-space slot="expected_rebate_amount" slot-scope="item, row, index">
          <span v-if="row.is_online_goods == 1"
            >¥{{ calculateExpectedRebate(row.order_amount) }}</span
          >
        </a-space>

        <a-space slot="action" slot-scope="item, row, index">
          <a-button
            type="primary"
            size="small"
            :disabled="!canRebate(row)"
            @click="handleRebate(row)"
          >
            返利
          </a-button>
        </a-space>
      </MyTable>
    </div>
  </div>
</template>
<script>
import MyTable from "@/components/myTable.vue";
import { orders_item, orders_rebate } from "@/api/orders";
import { brand_index } from "@/api/goods";
import { order_item } from "@/api/export";
import moment from "moment";
export default {
  components: { MyTable },
  data() {
    return {
      orders_item: orders_item,
      ajaxparams: {}, //请求参数
      /*
			列表header
		*/
      columns: [
        {
          title: "订单日期",
          width: 120,
          dataIndex: "ctime",
          key: "ctime",
          scopedSlots: { customRender: "ctime" },
        },
        {
          title: "订单号",
          width: 100,
          dataIndex: "order_sn",
          key: "order_sn",
          scopedSlots: { customRender: "order_sn" },
        },
        { title: "客户", width: 80, dataIndex: "name", key: "name" },
        {
          title: "品牌",
          width: 120,
          dataIndex: "brand_id",
          key: "brand_id",
          scopedSlots: { customRender: "brand_id" },
        },
        {
          title: "省份",
          width: 150,
          dataIndex: "province_code",
          key: "province_code",
          scopedSlots: { customRender: "province_code" },
        },
        {
          title: "发货状态",
          width: 100,
          dataIndex: "is_delivery",
          key: "is_delivery",
          scopedSlots: { customRender: "is_delivery" },
        },
        {
          title: "商品名称",
          width: 250,
          dataIndex: "goods_name",
          key: "goods_name",
        },
        {
          title: "规格名称",
          width: 300,
          dataIndex: "goods_spec_desc",
          key: "goods_spec_desc",
        },
        { title: "商品数量", width: 100, dataIndex: "num", key: "num" },
        {
          title: "商品单价",
          width: 100,
          dataIndex: "price",
          key: "price",
          scopedSlots: { customRender: "price" },
        },
        {
          title: "商品金额",
          width: 100,
          dataIndex: "goods_amount",
          key: "goods_amount",
          scopedSlots: { customRender: "goods_amount" },
        },
        {
          title: "订单金额",
          width: 100,
          dataIndex: "order_amount",
          key: "order_amount",
          scopedSlots: { customRender: "order_amount" },
        },
        {
          title: "订单支付金额",
          width: 100,
          dataIndex: "payed_amount",
          key: "payed_amount",
          scopedSlots: { customRender: "payed_amount" },
        },
        {
          title: "共富币支付",
          width: 100,
          dataIndex: "payed_coin",
          key: "payed_coin",
          scopedSlots: { customRender: "payed_coin" },
        },
        {
          title: "返利金额",
          width: 100,
          dataIndex: "online_goods_refund_amount",
          key: "online_goods_refund_amount",
          scopedSlots: { customRender: "online_goods_refund_amount" },
        },
        {
          title: "预期返利金额",
          width: 120,
          dataIndex: "order_amount",
          key: "expected_rebate_amount",
          scopedSlots: { customRender: "expected_rebate_amount" },
        },
        {
          title: "操作",
          width: 100,
          key: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      submitLoading: false,
      regionData: [],
      brandData: [],
      provinceData: [],
    };
  },
  mounted() {
    this.regionData = this.$db.get("regionList").data;
    brand_index({ page: 1, limit: 100 }).then((res) => {
      this.brandData = res.list;
    });
    this.provinceData = this.regionData.filter((item) => {
      return item.depth == 1;
    });
  },
  computed: {},
  watch: {
    // 返利订单的选择变化
    "ajaxparams.is_online_goods": function (newVal) {
      if (newVal === "1") {
        this.setDefaultRebateTimeRange();
      } else if (newVal === "2") {
        this.ajaxparams["2_ctime_between"] = null;
      } else {
        this.ajaxparams["2_ctime_between"] = null;
      }
    },
  },
  methods: {
    getRequestParams() {
      const params = { ...this.ajaxparams };
      if (params.is_online_goods === "2") {
        params.is_online_goods = "1";
      }

      return params;
    },

    setDefaultRebateTimeRange() {
      const currentTime = new Date();
      const oneYearAgo = new Date(
        currentTime.getTime() - 365 * 24 * 60 * 60 * 1000
      );
      const startDate = "2022-01-01";
      const endDate = moment(oneYearAgo).format("YYYY-MM-DD");

      this.ajaxparams["2_ctime_between"] = [startDate, endDate];
    },

    //执行搜索
    doExport() {
      //导出
      if (!this.ajaxparams["2_ctime_between"]) {
        this.$message.warning("请选择导出日期");
        return;
      }
      order_item(this.getRequestParams()).then(
        (res) => {
          this.$message.success("添加导出队列成功");
          this.$db.set("is_export", 1);
        },
        (err) => {
          this.$message.warning("导出失败");
        }
      );
    },

    returnRegionName(code) {
      let rest = this.regionData.find((item) => {
        return code == item.code;
      });
      if (rest) {
        return rest.name;
      }
      return "";
    },
    findProvinceName(code) {
      let rest = this.regionData.find((item) => {
        return code == item.code;
      });
      if (rest) {
        return rest.name;
      }
      return "";
    },
    findBrandName(id) {
      let rest = this.brandData.find((item) => {
        return id == item.id;
      });
      if (rest) {
        return rest.brand_name;
      }
      return "";
    },

    // 计算预期返利金额
    calculateExpectedRebate(orderAmount) {
      if (!orderAmount || orderAmount === 0) {
        return "0.00";
      }
      const rebateInCents = Math.round(orderAmount * 0.125);
      const rebateInYuan = rebateInCents / 100;
      return rebateInYuan.toFixed(2);
    },

    // 判断是否可以进行返利
    canRebate(row) {
      if (!row.ctime) {
        return false;
      }

      // 如果返利金额不为0，已经返利过了
      if (
        row.online_goods_refund_amount &&
        row.online_goods_refund_amount > 0
      ) {
        return false;
      }

      // 获取订单创建时间
      const orderCreateTime = new Date(row.ctime);
      const currentTime = new Date();
      const timeDiff = currentTime.getTime() - orderCreateTime.getTime();
      const oneYear = 365 * 24 * 60 * 60 * 1000;
      return timeDiff >= oneYear;
    },

    // 处理返利操作
    async handleRebate(row) {
      try {
        // 确认对话框
        this.$confirm({
          title: "确认返利",
          content: `确定要对订单 ${row.order_sn} 进行返利操作吗？`,
          onOk: async () => {
            const loading = this.$message.loading("返利处理中...", 0);
            try {
              const result = await orders_rebate({
                id: row.order_id,
              });
              loading();
              this.$message.success("返利操作成功");
              this.$refs.myTable.getList();
            } catch (error) {
              loading();
              console.error("返利操作失败:", error);
              this.$message.error("返利操作失败");
            }
          },
        });
      } catch (error) {
        console.error("返利操作异常:", error);
        this.$message.error("返利操作异常");
      }
    },
  },
};
</script>
